document.addEventListener('click', function (event) {
  //if the clicked element is a category display toggle
  if (event.target.matches('.category-display-option')) {
    //prevent default events
    event.preventDefault(); //fetch the value of this button

    var type = event.target.value; //update the display mode attribute on the body

    this.body.dataset.display_mode = type; //push this type to the URL

    history.pushState({}, null, window.location.href.split('?')[0] + '?display=' + type);
  }
}, false);